import { Cmdtypes } from 'src/constants/cmdtypes'
import { ResponseDataType } from 'src/types/websocket'

export interface PublishOptions {
  targetOrigin: string
  targetWindow: Window
}

export interface SubscribeOptions {
  targetWindow: Window
}

const defaultPublishOptions: PublishOptions = {
  targetOrigin: '*',
  targetWindow: window,
}

const defaultSubscribeOptions: SubscribeOptions = {
  targetWindow: window,
}

const publish = <T>(
  responseData: ResponseDataType<T>,
  options: PublishOptions = defaultPublishOptions,
) => {
  options.targetWindow.postMessage(responseData, options.targetOrigin)
}

const subscribe = <T>(
  cmdtype: Cmdtypes,
  handler: (message: ResponseDataType<T>) => void,
  options: SubscribeOptions = defaultSubscribeOptions,
) => {
  const messageEventHandler = (event: MessageEvent) =>
    subscriptionHandler<T>(event, cmdtype, handler)

  const attachEventListener = () => {
    options.targetWindow.addEventListener('message', messageEventHandler)
  }
  const detachEventListener = () => {
    options.targetWindow.removeEventListener('message', messageEventHandler)
  }

  attachEventListener()
  return { unsubscribe: detachEventListener }
}
const subscriptionHandler = <T>(
  event: MessageEvent,
  cmdtype: Cmdtypes,
  handler: (message: ResponseDataType<T>) => void,
) => {
  event.data.CmdType === cmdtype && handler(event.data)
}

export const eventBus = {
  publish,
  subscribe,
}
